import SignUpModal from '@/components/auth/SignUpModal';

const SignUpPage = () => {
  return <SignUpModal />;
};

export default SignUpPage;
